export enum SavedFilterStatus {
    active = 'active',
    inactive = 'inactive',
}

export enum SavedFilterType {
    settings = 'settings',
    filter = 'filter',
}

export enum SavedFilterSubType {
    sites = 'sites',
    nominations = 'nominations',
    agreements = 'admin/agreements',
    eventAnalytics = 'event-analytics/performance',
    energyUsageDataAnalytics = 'energy-usage-data/analytics',
    customerVens = 'customer-vens',
    cloudVens = 'cloud-vens',
    marketAwards = 'market-awards',
    vendorBillItems = 'vendor-bill-items',
    eventTracking = 'event-tracking',
    readinessTracking = 'readiness-tracking',
    eventCompanyParticipation = 'event-company-participation',
    pjmLocations = 'pjm-locations',
    pjmRegistrations = 'pjm-registrations',
    customerUtilityBills = 'customer-utility-bills',
    customerUtilityBillFiles = 'customer-utility-bill-files',
}

export interface ISavedFilter {
    id: number;
    user_id: number;
    user_name: string;
    filter_values: Record<string, any>; // TODO: Fix types
    description?: string;
    status: SavedFilterStatus;
    type: SavedFilterType;
    sub_type: SavedFilterSubType;
    filter_name: string;
    modified_by_user_name: string;
    date_created: Date;
    date_modified: Date;
    display_in_dashboard: boolean;

    isOutdated?: boolean;
    outdatedFields?: string[];
}

export interface ICreateSavedFilter {
    id: number | null;
    filter_values: Record<string, any>; // TODO: Fix types
    description?: string;
    status: string;
    type: string;
    sub_type: string;
    filter_name: string;
    display_in_dashboard?: boolean;
}
